import { fetchPageBanner } from '~~/server/api/newsApi'
import { fetchNewsHomePageList } from '~~/server/api/newsApi'
import { fetchIndustryGetAll } from '~~/server/api/newsApi'
import {
  clientFetchExhibitionDimension,
  clientFetchExhibitionSearch,
  fetchCityByType,
  fetchClientExhibitionSearch,
  fetchExhibitionList
} from '~~/server/api/exhibition'
import { useRoute, useRouter } from '#vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import {
  alphabet,
  checkDevice,
  getWhiteScreenTime,
  handleNodeServerError,
  handleCheckUrl,
  batchProcessRequests
} from '~/utils/common'
import _ from 'lodash'
import { ResponseCode } from '~/utils/constant'
import dayjs from 'dayjs'
import { fetchOSSNewsContent } from '~~/server/api/auth'
import { fetchInnerChainPage } from '~~/server/api/newsApi'
import { useLang } from '~/composables/useLang'
import { ELocale } from '~~/types/enums'

export const useFairList = async (_lang: ELocale) => {
  const { $logger, ...$nuxt } = useNuxtApp()
  const globalStore = useGlobalStore()
  const { t: $t } = useI18n()
  const route = useRoute()
  const router = useRouter()
  const { keyword: _keyword, sort, type: _sortType } = route.query
  const { lang } = useLang(_lang)
  const routeParams = reactive<Record<string, string>>({
    firstIndustryId: (route.params.f as string) || '0', // 一级行业ID，默认为 '0'
    secondIndustryId: (route.params.s as string) || '0', // 二级行业ID，默认为 0
    area: (route.params.g as string) || '9999', // 地区ID（1为国内，0为国际），默认 9999表示全部
    province: (route.params.p as string) || '0', // 省份ID（国内）或国家ID（国际），默认 0
    city: (route.params.c as string) || '0', // 城市ID，默认 0
    date: (route.params.t as string) || '0', // 时间，格式为月份 1-12，默认 '0'
    page: (route.params.page as string) || '1' // 分页，默认第 1 页
  })
  let { firstIndustryId, secondIndustryId, area, province, city, date, page } =
    toRefs<Record<string, string>>(routeParams)

  // const isLogin = computed(() => globalStore.isLogin)
  let isLogin = ref(null as any)
  if (import.meta.client) {
    isLogin = computed(() => globalStore.isLogin)
  }
  const type = ref('0') // 国内
  const keyword = ref<string>((_keyword || '') as string)
  const keywordError = ref(false)
  const keywordPlaceholder = ref($t('home.top_container.inputPlaceholder'))
  const sortType = ref(sort)
  const moreDate = ref(false)
  const moreCity = ref(false)
  const moreArea = ref(false)
  const pagination = ref(true)
  let isRecommond = ref(false) // 是否显示行业推荐, 默认不显示
  const activeSort = ref(route.query.type)
  const innerChainActive = ref(0)
  const cityList = ref<any[]>([])
  const azList = ref<string[]>(alphabet)
  const scale = ref({
    sortStr: 'scale',
    sortType: 'asc'
  })
  const hot = ref({
    sortStr: 'hot',
    sortType: 'asc'
  })
  const start_time = ref({
    sortStr: 'start_time',
    sortType: 'asc'
  })
  const hotCityList = ref([
    {
      name: '北京',
      enName: 'Beijing',
      areaId: 1,
      regionId: 11,
      cityId: 1051
    },
    {
      name: '天津',
      enName: 'Tianjin',
      areaId: 1,
      regionId: 523,
      cityId: 1052
    },
    {
      name: '上海',
      enName: 'Shanghai',
      areaId: 1,
      regionId: 519,
      cityId: 1123
    },
    {
      name: '广州',
      enName: 'Guangzhou',
      areaId: 1,
      regionId: 528,
      cityId: 1250
    },
    {
      name: '深圳',
      enName: 'Shenzhen',
      areaId: 1,
      regionId: 528,
      cityId: 1252
    },
    {
      name: '重庆',
      enName: 'Chongqing',
      areaId: 1,
      regionId: 524,
      cityId: 1305
    }
  ])
  const hotCityList2 = ref([
    {
      name: '东京',
      enName: 'Tokyo',
      areaId: 2,
      regionId: 9,
      cityId: 1578
    },
    {
      name: '迪拜',
      enName: 'Dubai',
      areaId: 50,
      regionId: 59,
      cityId: 1980
    },
    {
      name: '胡志明',
      enName: 'Hanoi',
      areaId: 2,
      regionId: 32,
      cityId: 1680
    },
    {
      name: '法兰克福',
      enName: 'Frankfurt',
      areaId: 3,
      regionId: 73,
      cityId: 1650
    },
    {
      name: '莫斯科',
      enName: 'Moscow',
      areaId: 3,
      regionId: 75,
      cityId: 1799
    },
    {
      name: '圣保罗',
      enName: 'Sao Paulo',
      areaId: 6,
      regionId: 230,
      cityId: 1856
    }
  ])

  const typeList = ref([
    {
      label: $t('exhibition.filters.domesticExh'),
      langKey: 'exhibition.filters.domesticExh',
      value: '0',
      key: 'domesticExh'
    },
    {
      label: $t('exhibition.filters.international'),
      langKey: 'exhibition.filters.international',
      value: '1',
      key: 'international'
    }
  ])
  // watch(isLogin, v => {})

  onMounted(() => {
    getWhiteScreenTime()
    if (checkDevice() == 'h5') {
      let url = `https://m.jufair.com${route.path}`
      // window.location.replace(url)
    }
  })

  let apiErrorList: any = []

  const currentYear: number = new Date().getFullYear() // 当前年份
  const currentMonth: number = new Date().getMonth() // 当前月份
  let dateYearMonth: string = '' // 年月 格式:202409

  /**
   * 重定向 原来广州与省份同级，现在要重定向到广东-广州
   * 广州604 重定向到 广东528，广州1250
   * 深圳520  重定向到 广东528，深圳1252
   * 宁夏银川 1046  重定向到 宁夏1570，银川1571
   * 拉萨 1562  重定向 西藏1572  ，拉萨1352
   *
   * */
  if (province.value === '604') {
    let newUrl = handleCheckUrl(
      `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-1-528-1250-${date.value}-1`,
      'list-1001'
    )
    navigateTo(newUrl, { external: true, redirectCode: 301 })
  }
  if (province.value === '520') {
    let newUrl = handleCheckUrl(
      `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-1-528-1252-${date.value}-1`,
      'list-1002'
    )
    navigateTo(newUrl, { external: true, redirectCode: 301 })
  }
  if (province.value === '1046') {
    let newUrl = handleCheckUrl(
      `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-1-1570-1571-${date.value}-1`,
      'list-1003'
    )
    navigateTo(newUrl, { external: true, redirectCode: 301 })
  }
  if (province.value === '1562') {
    let newUrl = handleCheckUrl(
      `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-1-1572-1352-${date.value}-1`,
      'list-1004'
    )
    navigateTo(newUrl, { external: true, redirectCode: 301 })
  }
  if (page.value == '0') {
    throw createError({
      statusMessage: 'PageNotFound-p',
      statusCode: 404
    })
  }
  const pageNum = isNaN(+page.value) ? 1 : +page.value
  const pageSize = 12

  if (+area.value === 1) {
    type.value = '0'
  } else {
    type.value = '1'
  }
  // 判断国外/国内后，再判断是否为全部
  if (+area.value === 9999) {
    type.value = '9999'
  }

  let countList: any = []

  if (import.meta.server) {
    $nuxt.ssrContext?.event.node.res.emit('phase1')
  }
  if (+firstIndustryId.value > 0 || +secondIndustryId.value > 0) {
    let params: any = {
      locale: lang
    }
    if (Number(type.value) != 9999) params['regionType'] = type.value
    if (+firstIndustryId.value > 0) params['industryId'] = firstIndustryId.value
    if (+secondIndustryId.value > 0) params['industryId'] = secondIndustryId.value
    // if (process.server) {
    const dimensionRes = await clientFetchExhibitionDimension(params)
    // console.log('264-', dimensionRes)
    if (dimensionRes?.code === ResponseCode.SUCCESS) {
      countList = dimensionRes?.data
    }
    // }
  }

  // 排序
  const sortObj: Record<string, any> = {}
  if (_sortType === 'scale' && sortType.value) {
    scale.value.sortType = sortType.value as string
    sortObj.sortScale = sortType.value
  } else if (_sortType === 'hot' && sortType.value) {
    hot.value.sortType = sortType.value as string
    sortObj.sortHot = sortType.value
  } else if (_sortType === 'start_time' && sortType.value) {
    start_time.value.sortType = sortType.value as string
    sortObj.sortTime = sortType.value
  }

  // 搜索列表
  let listParams: Record<string, any> = {
    locale: lang,
    pageNum,
    pageSize,
    regionType: type.value,
    selectTimeType: 1
    // regionId: '', // 洲id
    // cityId   // 城市id
    // sortStr: sort,
    // sortType,
    // time: moment().format('YYYY-MM-DD'),
  }
  listParams = Object.assign(listParams, sortObj)

  // 行业推荐
  let hotParams: Record<string, any> = {
    locale: lang,
    pageNum: 1,
    pageSize: 8,
    regionType: type.value,
    recommond: '2',
    selectTimeType: 1 // 0:查询当月的 1:查询给定时间之后的
  }
  hotParams = Object.assign(hotParams, sortObj)

  // 友情链接
  const handleFetchLinks = () => {
    if (+secondIndustryId.value > 0) {
      return globalStore.getLinks({ id: secondIndustryId.value })
    } else if (+firstIndustryId.value > 0) {
      return globalStore.getLinks({ id: firstIndustryId.value })
    }
    return Promise.resolve(null)
  }
  const _fetchLinks = handleFetchLinks()

  // 行业推荐
  const handleFetchExhibitionList = () => {
    if (+secondIndustryId.value > 0) {
      isRecommond.value = true // 二级行业有值, 显示行业推荐
      listParams.industryId = secondIndustryId.value || 0
      hotParams.industryId = secondIndustryId.value || 0
      //   console.log('????');
      return process.server ? fetchExhibitionList(listParams) : null // 行业推荐
    }
    return Promise.resolve(null)
  }
  const _fetchExhibitionList = handleFetchExhibitionList()

  // 地区行业资讯
  const handleFetchNewsHomePageList = () => {
    if (+secondIndustryId.value > 0 || +province.value > 0) {
      let newsParams: Record<string, any> = {
        locale: lang,
        pageNum: 1,
        pageSize: 7
      }

      if (+secondIndustryId.value > 0) newsParams['industryId'] = secondIndustryId.value
      if (Number(province.value) > 0) newsParams['areaId'] = province.value
      if (process.server) {
        return fetchNewsHomePageList(newsParams)
      } else {
        return null
      }
    }
    return Promise.resolve(null)
  }
  const _fetchNewsHomePageList = handleFetchNewsHomePageList()
  if (+firstIndustryId.value > 1) {
    listParams['industryId'] = +firstIndustryId.value
  }
  if (+secondIndustryId.value > 1) {
    listParams['industryId'] = +secondIndustryId.value
  }
  if (+area.value > 1 && +area.value != 9999) {
    listParams['regionId'] = +area.value
  }

  if (+province.value > 0) {
    listParams.area = province.value
  }

  if (+city.value > 0) {
    listParams['cityId'] = city.value
  }

  //   if (+date.value > 0) {
  //     if (date.value.length == 6) {
  //       date.value = date.value.slice(4); // 获取最后两位
  //     }
  //     // 日期格式错误 则算作当前月份 如：超出6位,
  //     if (
  //       date.value.length > 6 ||
  //       Number(date.value) < 1 ||
  //       Number(date.value) > 12 ||
  //       !Number(date.value)
  //     ) {
  //       date.value = String(currentMonth + 1);
  //     }
  //     // console.log('861-', date.value);
  //     if (Number(date.value) < currentMonth + 1) {
  //       dateYearMonth = `${currentYear + 1}${
  //         Number(date.value) < 10 ? '0' + Number(date.value) : date.value
  //       }`;
  //     } else {
  //       dateYearMonth = `${currentYear}${
  //         Number(date.value) < 10 ? '0' + Number(date.value) : date.value
  //       }`;
  //     }
  //     const dateTemp = `${dateYearMonth.slice(0, 4)}-${dateYearMonth.slice(4)}-01`;
  //     listParams.time = dayjs(new Date(dateTemp)).format('YYYY-MM-DD');

  //     if (listParams.time === 'Invalid date') {
  //       throw createError({
  //         statusCode: 404,
  //         statusMessage: 'PageNotFound-Invalid date',
  //       });
  //     }
  //   }
  // 日期301和404处理 404:"长度超出6位、长度大于2位小于6位、长度1位且小于1、长度2位且大于12、不是数字时"; 301:时间是6位 如:202408 或 长度2位,第一位是0 如: 08

  if (+date.value > 0 || isNaN(Number(date.value))) {
    // 日期格式错误 则算作当前月份 如：不是数字, 大于2位且小于6位, 超出6位,
    if (
      isNaN(Number(date.value)) ||
      (date.value.length > 2 && date.value.length < 6) ||
      date.value.length > 6 ||
      (date.value.length == 1 && Number(date.value) < 1) ||
      (date.value.length == 2 && Number(date.value) > 12)
    ) {
      // date.value = String(currentMonth + 1);
      throw createError({
        statusMessage: 'PageNotFound-d',
        statusCode: 404
      })
    }
    // 时间是6位 如:202408 或 长度2位,第一位是0 如: 08
    if (date.value.length == 6 || (date.value.length == 2 && String(date.value).slice(0, 1) == '0')) {
      if (date.value.length == 6) date.value = date.value.slice(4) // 长度6位时获取最后两位

      if (date.value.length == 2) {
        // 长度2位时转为number
        date.value = String(date.value).slice(0, 1) == '0' ? String(date.value).slice(1) : date.value //
      }
      // 月份是数字
      if (!isNaN(Number(date.value))) {
        let newUrl: any = handleCheckUrl(
          `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${Number(
            date.value
          )}-1`,
          'list-1005'
        )
        navigateTo(newUrl, { external: true, redirectCode: 301 })
      }
    }
    // 月份小于当前月，则年份+1, 如:当前是2024年11月，date是8, 则 最终要拼成2025-08-01
    if (Number(date.value) < currentMonth + 1) {
      dateYearMonth = `${currentYear + 1}${Number(date.value) < 10 ? '0' + Number(date.value) : date.value}`
    } else {
      dateYearMonth = `${currentYear}${Number(date.value) < 10 ? '0' + Number(date.value) : date.value}`
    }
    const dateTemp = `${dateYearMonth.slice(0, 4)}-${dateYearMonth.slice(4)}-01`
    listParams.time = dayjs(new Date(dateTemp)).format('YYYY-MM-DD')
    if (listParams.time === 'Invalid date') {
      throw createError({
        statusMessage: 'PageNotFound-数据不存在',
        statusCode: 404
      })
    }
  }

  let queryListByKeyWordParams = {}
  if (keyword.value) {
    keyword.value = keyword.value.replace(/[^a-zA-Z0-9\u4e00-\u9fa5 ]/g, '')
    queryListByKeyWordParams = {
      pageNum,
      pageSize: 12,
      keyWords: keyword.value,
      locale: lang
    }
    Object.assign(queryListByKeyWordParams, sortObj)
  }

  let areaType: any = ''
  if (area.value === '1') {
    areaType = 0
  } else {
    areaType = 1
  }

  const handleFetchExhibition = () => {
    if (listParams.regionType == 9999) {
      listParams.regionType = undefined
    }
    if (keyword.value) {
      listParams.keyWords = keyword.value
      return clientFetchExhibitionSearch(listParams)
      // console.log('queryListByKeyWordParams 404', queryListByKeyWordParams)
      // return clientFetchQueryListByKeyWord(queryListByKeyWordParams)
    } else {
      if (process.server) {
        return clientFetchExhibitionSearch(listParams)
      } else {
        return clientFetchExhibitionSearch(listParams)
      }
    }
  }
  const _fetchExhibition = handleFetchExhibition()

  // 数据优化函数 - 减少 __NUXT_DATA__ 大小
  const optimizeExhibitionListResponse = (res: any) => {
    if (_.get(res, 'code') === ResponseCode.SUCCESS) {
      return {
        ...res,
        data: {
          ...res?.data,
          records: (res?.data?.records || []).map((item: any) => ({
            // 基本标识字段
            exhibitionId: item.exhibitionId,
            exhibitionName: item.exhibitionName,
            exhibitionEnglishName: item.exhibitionEnglishName,

            // 显示信息字段
            pic: item.pic,
            logo: item.logo,
            tag: item.tag,

            // 时间和状态字段
            lunchTime: item.lunchTime,
            changeTime: item.changeTime,
            dynamic: item.dynamic,
            countDays: item.countDays,

            // 统计信息字段
            scale: item.scale,
            audience: item.audience,
            hot: item.hot,

            // 关注信息优化（只保留第一个关注者的公司名）
            exhibitionFollows:
              (item.exhibitionFollows || []).length > 0
                ? [
                    {
                      companyName: item.exhibitionFollows[0].companyName
                    }
                  ]
                : []
          }))
        }
      }
    }
    return res
  }

  const optimizeNewsResponse = (res: any) => {
    if (_.get(res, 'code') === ResponseCode.SUCCESS) {
      return {
        ...res,
        data: {
          ...res?.data,
          records: (res?.data?.records || []).map((item: any, idx: number) => {
            const isToday = dayjs().diff(dayjs(item.publishTime), 'days')
            const format = isToday > 1 ? 'MM-DD HH:mm' : 'HH:mm'
            return {
              newsId: item.newsId,
              viewUrl: item.viewUrl,
              newsName: item.newsName,
              logo: idx === 0 ? item.logo : undefined,
              views: item.views,
              createTime: dayjs(item.publishTime).format(format)
            }
          })
        }
      }
    }
    return res
  }

  const optimizeIndustryResponse = (res: any) => {
    if (_.get(res, 'code') === ResponseCode.SUCCESS) {
      return {
        ...res,
        data: (res?.data || []).map((item: any) => ({
          industryId: item.industryId,
          industryName: item.industryName,
          children: (item.children || []).map((child: any) => ({
            id: child.id,
            pid: child.pid,
            industryName: child.industryName
          }))
        }))
      }
    }
    return res
  }

  const optimizeCityResponse = (res: any) => {
    if (_.get(res, 'code') === ResponseCode.SUCCESS) {
      // 递归优化嵌套的areas字段
      const optimizeAreasRecursively = (areas: any[]): any[] => {
        if (!Array.isArray(areas)) return areas
        return areas.map((area: any) => {
          const optimizedArea: any = {
            id: area.id,
            area: area.area,
            regionName: area.regionName,
            exhibitionCount: area.exhibitionCount,
            hasData: area.hasData
          }
          // 只有当areas存在时才添加到结果中
          if (area.areas && Array.isArray(area.areas) && area.areas.length > 0) {
            optimizedArea.areas = optimizeAreasRecursively(area.areas)
          }
          return optimizedArea
        })
      }

      return {
        ...res,
        data: (res?.data || []).map((item: any) => {
          const optimizedItem: any = {
            id: item.id,
            area: item.area,
            regionName: item.regionName,
            exhibitionCount: item.exhibitionCount,
            hasData: item.hasData
          }
          // 按需优化嵌套的areas字段
          if (item.areas && Array.isArray(item.areas) && item.areas.length > 0) {
            optimizedItem.areas = optimizeAreasRecursively(item.areas)
          }
          return optimizedItem
        })
      }
    }
    return res
  }

  const { data, refresh } = await useAsyncData('fair-list-page-data', async () => {
    return await batchProcessRequests(
      [
        // Banner 数据字段优化 - 保持SSR模式
        async () => {
          const res = await fetchPageBanner({
            type: 4,
            channel: 0,
            industry1: firstIndustryId.value,
            industry2: secondIndustryId.value,
            areaType
          })
          if (_.get(res, 'code') === ResponseCode.SUCCESS) {
            return {
              ...res,
              data: (res?.data || []).map((item: any) => ({
                bannerUrlList: item.bannerUrlList,
                bannerLinkListPc: item.bannerLinkListPc
              }))
            }
          }
          return res
        }, // Banner数据

        // 新闻数据字段优化
        async () => {
          const res = await fetchNewsHomePageList({
            locale: lang,
            // newsType: 1,
            pageNum: 1,
            pageSize: 21
          })
          return optimizeNewsResponse(res)
        }, // 资讯列表

        // 行业数据字段优化
        async () => {
          const res = await fetchIndustryGetAll({ locale: lang })
          return optimizeIndustryResponse(res)
        }, // 行业列表

        // 城市数据字段优化
        async () => {
          const res = await fetchCityByType({ type: type.value })
          return optimizeCityResponse(res)
        }, // 地区列表

        // 展会数据字段优化
        async () => {
          const res = await _fetchExhibition
          return res ? optimizeExhibitionListResponse(res) : res
        }, // 展会列表

        // 地区新闻优化
        async () => {
          const res = await _fetchNewsHomePageList
          return res ? optimizeNewsResponse(res) : res
        },

        // 推荐展会优化
        async () => {
          const res = await _fetchExhibitionList
          return res ? optimizeExhibitionListResponse(res) : res
        },

        // @ts-ignore
        () => _fetchLinks // 友链
      ],
      { parallel: true }
    )
  })

  const [
    bannerRes, // Banner数据
    newsListRes, // 最新资讯
    industryRes,
    areaRes,
    fairRes,
    newsRes,
    hotFairRes
  ] = data.value || []

  // Banner 数据处理 - SSR 模式，数据已优化
  const banner: any[] = []
  if (_.get(bannerRes, 'code') === ResponseCode.SUCCESS) {
    for (let i = 0; i < bannerRes?.data.length; i++) {
      const url = bannerRes?.data[i]?.bannerUrlList
      const link = bannerRes?.data[i]?.bannerLinkListPc
      banner.push({
        url,
        link
      })
    }
  }

  let newsList = ref<any[]>([])
  //   console.log('newsListRes =>', newsListRes?.value);
  if (_.get(newsListRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，直接使用
    newsList.value = newsListRes?.data.records || []
  }

  let industry: any[] = []
  //   console.log('1160-',industryRes.value)
  if (_.get(industryRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，直接使用
    industry = industryRes?.data || []
  }

  let areas: any[] = [] // 第一级中国(国内) - 二级省份列表, 洲列表(国际) - 二级国家列表

  if (_.get(areaRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，直接使用
    areas = areaRes?.data || []

    areas.map((i: any) => {
      i['hasData'] = true
      if (i.areas) {
        i.areas.map((j: any) => {
          j['hasData'] = true
        })
        // 按exhibitionCount(展会数量)排序
        i.areas.sort((a: any, b: any) => b.exhibitionCount - a.exhibitionCount)
      }
    })
  }

  // let fair: Record<string, any> = {}
  const fair = ref<Record<string, any>>({})

  if (_.get(fairRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，直接使用
    fair.value = fairRes?.data

    if (pageNum > 1 && pageNum > fairRes?.data.pages) {
      throw createError({
        statusMessage: 'PageNotFound-数据不存在',
        statusCode: 404
      })
    }
  } else {
    if (process.server) {
      apiErrorList.push({
        api: '/api/exhibition/search',
        params: listParams,
        code: fairRes?.code,
        message: fairRes?.message,
        errorMessage: 'fairRes'
      })
      handleNodeServerError(JSON.stringify(apiErrorList))
    }
  }

  const news: any[] = []
  if (_.get(newsRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，但保留第一条新闻的详细描述逻辑
    const records = newsRes?.data?.records || []
    for (let index = 0; index < records.length; index++) {
      const item = records[index]
      const description =
        index === 0 && item.newsId
          ? process.server
            ? await fetchOSSNewsContent({ newsId: item.newsId }).catch()
            : null
          : undefined

      // 使用优化后的数据，但添加必要的描述字段
      news.push({
        ...item, // 使用已优化的字段
        description: description // 添加描述字段
      })
    }
  }

  let hotFair: Record<string, any> = {}
  //   console.log('hotFair =>', hotFairRes.value);
  if (_.get(hotFairRes, 'code') === ResponseCode.SUCCESS) {
    // 数据已在源头优化，直接使用
    hotFair = hotFairRes?.data || {}
  }

  const dateList: any[] = []
  for (let i = 0; i < 12; i++) {
    const date = dayjs()
      .set('year', currentYear)
      .set('month', currentMonth + i)
    dateList.push({
      label: date.format($t('exhibition.filters.dateFormat')),
      value: date.format('M'), // YYYYMM
      value2: date.format('YYYY-MM'),
      hasData: true
    })
  }

  // 检查筛选条件展会数据
  // 如果勾选了二级行业id,则检查二级行业
  let checkIndustry = (v: any) => {
    // console.log('821--行业', v, secondIndustryId.value, routeParams.secondIndustryId)
    return routeParams.secondIndustryId > 0 ? v == routeParams.secondIndustryId : true
  }
  // 如果勾选了地区(国家/省份),则检查areaId
  let checkAreaId = (v: any) => {
    // console.log('821--地区', v, province.value, routeParams.province)
    return routeParams.province > 0 ? v == routeParams.province : true
  }
  // 如果勾选了城市,则检查areaId
  let checkCityId = (v: any) => {
    // console.log('821--城市', v, city.value, routeParams.city)
    return routeParams.city > 0 ? v == routeParams.city : true
  }

  // 勾选时间
  let checkDate = (v: any) => {
    let timeStr = +date > 0 ? dateYearMonth.slice(0, 4) + '-' + dateYearMonth.slice(4, 6) : '--'
    // console.log('1180-', timeStr);
    return +date > 0 ? v.includes(timeStr) : true
  }

  if (+firstIndustryId.value > 0 || +secondIndustryId.value > 0) {
    dateList.map((dateItem: any) => {
      dateItem['hasData'] = !!countList.some(
        (i: any) =>
          i.startTime.includes(dateItem.value2) &&
          checkIndustry(i.industryId) &&
          checkAreaId(i.areaId) &&
          checkCityId(i.cityId)
      ) // true有数据, false无数据
    })
    // console.log('852--', dateList)
  }

  // 已选条件
  const checkTags: any[] = []
  let secondIndustry: any[] = []
  if (+firstIndustryId.value > 0) {
    // 已选一级行业
    const item = industry.find((item: any) => item.industryId == firstIndustryId.value)
    secondIndustry = item?.children // 二级行业
    checkTags.push({
      name: item?.industryName,
      type: 'firstIndustry',
      id: firstIndustryId.value
    })
  }
  if (+secondIndustryId.value > 0) {
    // 已选二级行业
    const item = secondIndustry?.find((item: any) => item.id == secondIndustryId.value)
    if (!item) {
      // 如果二级行业id不存在,则重定向为0
      let newUrl: any = handleCheckUrl(
        `/exhibition-${firstIndustryId.value}-0-${area.value}-${province.value}-0-${date.value}-1`,
        'list-668'
      )
      navigateTo(newUrl, { external: true, redirectCode: 301 })
    }
    // secondIndustryName = item?.industryName;
    checkTags.push({
      name: item?.industryName,
      type: 'secondIndustry',
      id: secondIndustryId.value,
      pid: firstIndustryId.value
    })
  }

  if (+area.value > 0 && +area.value != 9999) {
    const item = areas.find((item: any) => item.id == area.value)
    if (!item) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found-4'
      })
    }

    cityList.value = item?.areas
    // cityList.map((i: any) => (i['hasData'] = true));

    checkTags.push({
      name: item?.regionName,
      type: 'area',
      id: item?.id
    })
  }

  let provinceCityList: any[] = [] // 当前选中省份的城市列表

  if (+province.value > 0) {
    const item = cityList.value.find((item: any) => item.id == province.value)
    // console.log('1332-', province.value, cityList.value)
    let cityRes: any = cityList.value.find((i: any) => province.value == i.id) // .areas || []; // 国外城市列表可能为空
    provinceCityList = cityRes && cityRes.areas ? cityRes.areas : []

    provinceCityList.map((i: any) => {
      i['hasData'] = true
    })
    // 按exhibitionCount(展会数量)排序
    provinceCityList.sort((a: any, b: any) => b.exhibitionCount - a.exhibitionCount)

    if (!item) {
      // console.log('1341-',apiErrorList)
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found-5'
      })
    }
    checkTags.push({
      name: item?.area,
      type: 'province',
      id: item?.id
    })
  }
  if (+city.value > 0) {
    const item = provinceCityList.find((item: any) => item.id == city.value)
    if (!item) {
      // 如果城市id不存在,将城市id重定向为0
      let newUrl: any = handleCheckUrl(
        `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-0-${date.value}-1`,
        'list-732'
      )
      navigateTo(newUrl, { external: true, redirectCode: 301 })
    }
    checkTags.push({
      name: item?.area,
      type: 'province',
      id: item?.id
    })
  }
  if (+date.value > 0) {
    // 已选时间
    const item = dateList.find((item: any) => item.value === date.value)
    checkTags.push({
      name: item?.label || dayjs(dateYearMonth).format('YYYY年MM月'),
      type: 'date',
      id: item?.value || dateYearMonth
    })
  }

  if (keyword.value) {
    checkTags.push({
      name: keyword.value,
      type: 'keyword',
      id: keyword.value
    })
  }

  // 展会时间 检查展会数量
  // dateList.map((dateItem: any) => {
  //   dateItem['hasData'] = countList.some(
  //     (i: any) =>
  //       i.startTime.includes(dateItem.value2) && checkIndustry(i.industryId)
  //   )
  //     ? true
  //     : false; // true有数据, false无数据
  // });

  // 地区 检查展会数量
  if (+firstIndustryId.value > 0 || +secondIndustryId.value > 0) {
    cityList.value.map((item: any) => {
      item['hasData'] = !!countList.some(
        (i: any) => i.areaId == item.id && checkIndustry(i.industryId) && checkDate(i.startTime)
      ) // true有数据, false无数据
    })
    // 国际-洲-国家-城市 检查是否有展会
    if (+area.value === 0) {
      areas.map((item: any) => {
        item['hasData'] = !!countList.some(
          (i: any) => i.region == item.area && checkIndustry(i.industryId) && checkDate(i.startTime)
        ) // true有数据, false无数据
        // 国家

        item.areas.map((x: any) => {
          x['hasData'] = !!countList.some(
            (i: any) => i.areaId == x.id && checkIndustry(i.industryId) && checkDate(i.startTime)
          )
          // 城市
          if (x.areas && x.areas.length > 0) {
            x.areas.map((y: any) => {
              y['hasData'] = !!countList.some(
                (i: any) => i.areaId == y.id && checkIndustry(i.industryId) && checkDate(i.startTime)
              )
            })
          }
        })
      })
    }

    // 按exhibitionCount(展会数量)排序
    // cityList.sort(
    //   (a: any, b: any) => b.exhibitionCount - a.exhibitionCount
    // );
    // 根据hasData排序,true排前面
    cityList.value.sort((a: any, b: any) => {
      if (a.hasData && !b.hasData) {
        return -1 // a在b前面
      } else if (!a.hasData && b.hasData) {
        return 1 // b在a前面
      }
      return 0 // 顺序不变
    })

    // 城市 检查展会数量
    provinceCityList.map((item: any) => {
      // hasData true有展会数据, false没有展会数据
      item['hasData'] = !!countList.some(
        (i: any) => i.cityId == item.id && checkIndustry(i.industryId) && checkDate(i.startTime)
      )
    })
  }

  // 第二次其他查询
  const handleFetchOtherExhibitionList = () => {
    if (fair?.records?.length <= 1) {
      let otherParams: any = {
        industryId: secondIndustryId.value || '',
        pageNum: 1,
        pageSize: 5,
        regionType: type.value,
        selectTimeType: 1,
        sortTime: 'asc'
      }
      // 如果已选择二级行业,则不加地区去查询; 如果没选二级行业,才能用地区去查询
      if (province.value && +secondIndustryId.value === 0) otherParams['area'] = province.value
      // if(city) otherParams["cityId"] = city;

      return fetchExhibitionList(otherParams)
    }
    return Promise.resolve(null)
  }

  // 侧边栏数据SSR处理 - 字段优化，减少数据传输量
  // 内链参数处理
  let paramsIndustry = []
  // if (secondIndustryId.value) paramsIndustry.push(secondIndustryId.value)
  // if (firstIndustryId.value) paramsIndustry.push(firstIndustryId.value)
  if (!isNaN(Number(secondIndustryId.value)) && Number(secondIndustryId.value) > 0)
    paramsIndustry.push(secondIndustryId.value)
  if (!isNaN(Number(firstIndustryId.value)) && Number(firstIndustryId.value) > 0)
    paramsIndustry.push(firstIndustryId.value)
  // 侧边栏数据优化函数
  const optimizeInnerChainResponse = (res: any) => {
    if (_.get(res, 'code') === ResponseCode.SUCCESS) {
      return {
        ...res,
        data: {
          ...res?.data,
          records: (res?.data?.records || []).map((item: any) => ({
            id: item.id,
            content: item.content,
            url: item.url,
            countryEnglishName: item.countryEnglishName
          }))
        }
      }
    }
    return res
  }

  const otherRequestList = [
    useAsyncData('fair-list-comp-other-exhibitions', async () => {
      const res = await handleFetchOtherExhibitionList()
      return res ? optimizeExhibitionListResponse(res) : res
    }),
    useAsyncData('fair-list-comp-hot-areas', async () => {
      const res = await fetchInnerChainPage({
        category: '热门地区',
        pageSize: 16
      })
      return optimizeInnerChainResponse(res)
    }),
    useAsyncData('fair-list-comp-hot-industries', async () => {
      const res = await fetchInnerChainPage({
        category: '热门行业',
        industryIdList: paramsIndustry,
        pageSize: 16
      })
      return optimizeInnerChainResponse(res)
    }),
    useAsyncData('fair-list-comp-hot-exhibitions', async () => {
      const res = await fetchInnerChainPage({
        category: '热门展会',
        industryIdList: paramsIndustry,
        pageSize: 16
      })
      return optimizeInnerChainResponse(res)
    })
  ]

  const otherResult = await Promise.all(otherRequestList)
  const [
    { data: otherFairRes },
    { data: innerChainAreaRes },
    { data: innerChainIndustryRes },
    { data: innerChainExhRes }
  ] = otherResult

  let otherFairList: any[] = [] // 同行业的其它展会, 查询5条
  let innerChainAreaList: any[] = []
  let innerChainIndustryList: any[] = []
  let innerChainExhList: any[] = []

  // 使用已优化的侧边栏数据
  if (_.get(otherFairRes, 'value.code') === ResponseCode.SUCCESS) {
    otherFairList = otherFairRes?.value?.data.records || []
  }

  if (_.get(innerChainAreaRes, 'value.code') === ResponseCode.SUCCESS) {
    innerChainAreaList = innerChainAreaRes?.value?.data.records || []
  }

  if (_.get(innerChainIndustryRes, 'value.code') === ResponseCode.SUCCESS) {
    innerChainIndustryList = innerChainIndustryRes?.value?.data.records || []
  }

  if (_.get(innerChainExhRes, 'value.code') === ResponseCode.SUCCESS) {
    innerChainExhList = innerChainExhRes?.value?.data.records || []
  }
  if (import.meta.server) {
    $nuxt.ssrContext?.event.node.res.emit('phase2')
  }
  // 设置一个自定义响应头(nuxtTraceId 记录日志位置)
  if (import.meta.server) {
    let interfaceResponseTime = globalStore.interfaceResponseTime
    // console.log('asyncData-end', interfaceResponseTime);
    const header = useResponseHeader('nuxtTraceId')
    header.value = interfaceResponseTime
    // $logger?.info(interfaceResponseTime);
  }
  globalStore.setInterfaceResponseTime('')

  //   if (apiErrorList.length > 0) {
  //     handleNodeServerError(JSON.stringify(apiErrorList));
  //   }

  // 省列表(国内),地区(国际)  area 0国际
  let areaList = ref<any>([])
  const cityListFun = (moreArea: any, area: any, cityList: any) => {
    if (moreArea.value) {
      if (+area.value === 0) {
        return [] // areas;
      }
      return cityList.value || []
    } else {
      if (+area.value === 0) {
        return [] // areas?.slice(0, 8) || [];
      }
      return cityList.value?.slice(0, 7) || []
    }
  }
  if (import.meta.server) {
    areaList = cityListFun(moreArea, area, cityList)
  } else {
    areaList = computed(() => {
      return cityListFun(moreArea, area, cityList)
    })
  }

  // 城市列表
  const computedProvinceCityList = ref<any[]>([])
  if (moreCity.value) {
    computedProvinceCityList.value = provinceCityList
  } else {
    computedProvinceCityList.value = provinceCityList?.slice(0, 30) || []
  }
  let dates = ref<any[]>([])
  let datesHasData = ref<boolean>(0) // hasData为true的数据总数
  let datesHasDataList = dateList.filter((item: any) => item.hasData)
  datesHasData.value = datesHasDataList.length
  if (import.meta.client) {
    dates = computed(() => {
      return dateList
      // if (moreDate.value) {
      //   return dateList
      // } else {
      //   return dateList.slice(0, 6)
      // }
    })
  } else {
    // if (moreDate.value) {
    //   dates.value = dateList
    // } else {
    //   dates.value = dateList.slice(0, 6)
    // }
    dates.value = dateList
  }

  const getBrandName = ref<string>('')
  const getBrandNamefun = () => {
    let tags = checkTags
    const obj: Record<string, any> = {}
    tags?.forEach((tag: any) => {
      if (!obj.hasOwnProperty(tag.type)) obj[tag.type] = tag.name // obj添加属性前检查属性是否存在
    })

    let name = ''
    if (obj.date) {
      name += obj.date
    }
    if (obj.province) {
      name += obj.province
    } else if (obj.area) {
      name += obj.area
    }
    if (obj.secondIndustry) {
      name += obj.secondIndustry
    } else if (obj.firstIndustry) {
      name += obj.firstIndustry
    }
    getBrandName.value = `${name}`
  }
  getBrandNamefun()

  const getBrandNameIndustry = ref<string>('')
  const getBrandNameIndustryfun = () => {
    let tags = checkTags
    const obj: Record<string, any> = {}
    tags?.forEach((tag: any) => {
      if (!obj.hasOwnProperty(tag.type) && tag.type != 'firstIndustry') obj[tag.type] = tag.name // obj添加属性前检查属性是否存在,排除一级行业名称
    })
    let name = ''
    if (obj.secondIndustry) {
      name += obj.secondIndustry
    } else if (obj.firstIndustry) {
      name += obj.firstIndustry
    }
    getBrandNameIndustry.value = `${name}`
  }
  getBrandNameIndustryfun()

  // filters
  const sectionTitle1 = (tags: Record<string, any>[], suffixText: string) => {
    const secondIndustry = tags?.find(item => item.type === 'secondIndustry')

    if (secondIndustry?.name) {
      return `${secondIndustry.name} ${suffixText}`
    }
    return suffixText
  }

  const sectionTitle2 = (tags: Record<string, any>[], suffixText: string, area: any) => {
    // console.log('677-', area, tags);
    let result = ''
    const secondIndustry = tags?.find(item => item.type === 'secondIndustry')

    if (secondIndustry?.name) {
      result = `${secondIndustry.name}${suffixText}`
    } else {
      result = '展会资讯'
    }
    // 地区名称(地区名称+城市名称)
    let areaListRes = tags?.filter(item => item.type === 'province')
    let areaName: string = ''
    if (areaListRes.length > 0) {
      areaListRes.map((i: any) => {
        areaName += i.name?.substr(-1) == '市' ? i.name?.substr(0, i.name.length - 1) : i.name
      })
    }
    // if (areaName == '') areaName = area == 0 ? '国际' : '国内';
    return areaName + result || suffixText
  }

  const description = (item: Record<string, any>): any => {
    const content = item.description || item.content || ''

    const reg = /<[^>]+>/gi
    return content
      .replace(reg, '')
      .replace(/&nbsp;/g, '')
      .trim()
      .slice(0, 100)
  }

  const brandName = (tags: any[]): string => {
    // console.log('865-', tags);
    const obj: Record<string, any> = {}
    tags?.forEach(tag => {
      obj[tag.type] = tag.name
    })

    let name = ''

    if (obj.date) {
      name += obj.date + ' '
    }

    if (obj.province) {
      name += obj.province + ' '
    } else if (obj.area) {
      name += obj.area + ' '
    }

    if (obj.secondIndustry) {
      name += obj.secondIndustry
    } else if (obj.firstIndustry) {
      name += obj.firstIndustry
    }
    // console.log('866-', name);
    return `${name}`
  }

  const firstLink = (val: string): string => {
    const [firstIndustryId, secondIndustryId, area, province, city, date] = val.split('-').slice(1, 7)

    if (
      firstIndustryId === '0' &&
      secondIndustryId === '0' &&
      area === '0' &&
      province === '0' &&
      city === '0' &&
      date === '0'
    ) {
      return '/exhibition/'
    } else {
      return val
    }
  }

  // methods
  const handleKeywordInput = () => {
    if (!keyword.value) {
      keywordError.value = false
      keywordPlaceholder.value = $t('menu.keywordPlaceholder1')
    } else if (keyword.value.length > 50) {
      keywordError.value = true
      keywordPlaceholder.value = $t('menu.keyword_error2')
    } else {
      keywordError.value = !/^[a-zA-Z\u4E00-\u9FA5 \(\)（）]+$/.test(keyword.value)
      keywordPlaceholder.value = $t('menu.keywordPlaceholder3')
    }
  }

  const handleSearch = _.debounce(
    function () {
      if (!/^[0-9a-zA-Z\u4E00-\u9FA5 \(\)（）]+$/.test(keyword.value)) {
        keywordError.value = true
        ElMessage({
          type: 'error',
          message: $t('menu.keyword_error1')
          // offset: 500
        })
        return
      } else {
        keywordError.value = false
      }

      if (keyword?.value.length > 50) {
        keywordError.value = true
        ElMessage({
          type: 'error',
          message: $t('menu.keyword_error2')
          // offset: Math.ceil(window.innerHeight / 2)
        })
        return
      }
      if (keyword.value) {
        window.open(`/exhibition/?keyword=${keyword.value}`, '_blank')
      } else {
        ElMessage({
          type: 'info',
          message: $t('menu.keywordPlaceholder1')
        })
      }
    },
    500,
    { leading: true }
  )

  const newUrl = (item: any) => {
    let { firstIndustryId, secondIndustryId, area, province, city, date } = Object.assign({}, routeParams)

    switch (item.type) {
      case 'firstIndustry':
        firstIndustryId = '0'
        secondIndustryId = '0'
        break
      case 'secondIndustry':
        secondIndustryId = '0'
        break
      case 'area':
        province = '0'
        city = '0'
        if (area === '1') {
          area = '1'
        } else {
          area = '0'
        }
        break
      case 'province':
        province = '0'
        city = '0'
        break
      case 'city':
        city = '0'
        break
      case 'date':
        date = '0'
        break
      default:
        return '/exhibition/'
    }

    // console.log('newUrl =>', item, firstIndustryId, secondIndustryId, area, province, city, date, pageNum);

    if (
      firstIndustryId == '0' &&
      secondIndustryId == '0' &&
      area == '0' &&
      province == '0' &&
      city == '0' &&
      date == '0' &&
      pageNum == 1
    ) {
      return '/exhibition/'
    }
    if (keyword.value) {
      return handleCheckUrl(
        `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${date}-1/?keyword=${keyword.value}`,
        'list-1219'
      )
    }
    return handleCheckUrl(
      `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${date}-1/`,
      'list-1224'
    )
  }

  // 地址更多
  const handleAreaMore = () => {
    moreArea.value = !moreArea.value
  }
  // 城市更多
  const handleCityMore = () => {
    moreCity.value = !moreCity.value
  }
  // 时间更多
  const handleDateMore = () => {
    moreDate.value = !moreDate.value
  }

  // 获取展会列表
  const handleGetFairList = async ({ sortStr, sortType: _type }: Record<string, any>) => {
    const params = _.cloneDeep(route.query)
    let listParams: Record<string, any> = {
      locale: lang,
      pageNum: Number(params.page) || 1,
      pageSize: 12,
      selectTimeType: 1
    }

    if (+firstIndustryId.value || +secondIndustryId.value) {
      listParams['industryId'] = +secondIndustryId.value || +firstIndustryId.value
    }
    if (+area.value > 1 && +area.value != 9999) listParams['regionId'] = +area.value

    if (+province.value) listParams['area'] = +province.value
    if (+city.value) listParams['cityId'] = +city.value
    const sort = sortType.value === 'desc' ? 'asc' : 'desc'
    if (sortStr && _type) {
      activeSort.value = sortStr
      sortType.value = sort
      if (sortStr === 'scale') {
        scale.value.sortType = sort
        listParams['sortScale'] = sort
      } else if (sortStr === 'hot') {
        hot.value.sortType = sort
        listParams['sortHot'] = sort
      } else if (sortStr === 'start_time') {
        start_time.value.sortType = sort
        listParams['sortTime'] = sort
      }
    }

    let newdate: any = null
    let currentYear = new Date().getFullYear() // 当前年份
    let currentMonth = new Date().getMonth() // 当前月份
    let dateYearMonth = '' // 年月 格式:202409

    if (+date.value > 0) {
      if (String(date.value).length == 6) {
        newdate = date.value.slice(4) // 获取最后两位
      }
      // 日期格式错误 则算作当前月份 如：超出6位,
      if (String(date.value).length > 6 || +date.value < 1 || +date.value > 12 || !+date.value) {
        newdate = String(currentMonth + 1)
      }
      if (+date.value < currentMonth + 1) {
        dateYearMonth = `${currentYear + 1}${+date.value < 10 ? '0' + +date.value : date.value}`
      } else {
        dateYearMonth = `${currentYear}${+date.value < 10 ? '0' + +date.value : date.value}`
      }

      const dateTemp = `${dateYearMonth.slice(0, 4)}-${dateYearMonth.slice(4)}-01`

      listParams['time'] = dayjs(new Date(dateTemp)).format('YYYY-MM-DD')
    }

    const res = await fetchClientExhibitionSearch(listParams)
    // console.log('1335-', res)
    if (res.code === ResponseCode.SUCCESS) {
      // fair = res.data

      fair.value = res.data
    }
    // 获取当前URL
    let url = new URL(window.location.href)

    // 设置查询参数
    url.searchParams.set('sort', sort)
    url.searchParams.set('type', sortStr)

    // 使用pushState更新浏览器历史记录
    history.pushState({}, '', url)
    pagination.value = false
    await nextTick(() => {
      pagination.value = true
    })
    // 重置页数为第1页
    // window.location.href = `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${date.value}-1/?${qs.stringify(params)}`;
  }

  // 获取展会列表
  const handleGetFairList2 = async ({ sortStr, sortType: _type }: Record<string, any>) => {
    const params = _.cloneDeep(route.query)

    let listParams: Record<string, any> = {
      locale: lang,
      pageNum: Number(params.page) || 1,
      pageSize: 12,
      selectTimeType: 1
    }

    if (+firstIndustryId.value || +secondIndustryId.value) {
      listParams['industryId'] = +secondIndustryId.value || +firstIndustryId.value
    }
    if (+area.value > 1 && +area.value != 9999) listParams['regionId'] = +area.value
    if (+province.value) listParams['area'] = +province.value
    if (+city.value) listParams['cityId'] = +city.value
    const sort = sortType.value === 'desc' ? 'asc' : 'desc'
    if (sortStr && _type) {
      activeSort.value = sortStr
      sortType.value = sort
      if (sortStr === 'scale') {
        scale.value.sortType = sort
        listParams['sortScale'] = sort
      } else if (sortStr === 'hot') {
        hot.value.sortType = sort
        listParams['sortHot'] = sort
      } else if (sortStr === 'start_time') {
        start_time.value.sortType = sort
        listParams['sortTime'] = sort
      }
    }

    let date: any = String(params.t)
    let currentYear = new Date().getFullYear() // 当前年份
    let currentMonth = new Date().getMonth() // 当前月份
    let dateYearMonth = '' // 年月 格式:202409

    if (+date.value > 0) {
      if (date.value.length == 6) {
        date = date.value.slice(4) // 获取最后两位
      }
      // 日期格式错误 则算作当前月份 如：超出6位,
      if (date.value.length > 6 || +date.value < 1 || +date.value > 12 || !+date.value) {
        date = String(currentMonth + 1)
      }
      if (+date.value < currentMonth + 1) {
        dateYearMonth = `${currentYear + 1}${+date.value < 10 ? '0' + +date.value : date}`
      } else {
        dateYearMonth = `${currentYear}${+date.value < 10 ? '0' + +date.value : date}`
      }

      const dateTemp = `${dateYearMonth.slice(0, 4)}-${dateYearMonth.slice(4)}-01`
      listParams['time'] = dayjs(new Date(dateTemp)).format('YYYY-MM-DD')
    }

    const res = await fetchClientExhibitionSearch(listParams)
    if (res.code === ResponseCode.SUCCESS) {
      fair.value = res.data
    }
    // 获取当前URL
    let url = new URL(window.location.href)

    // 设置查询参数
    url.searchParams.set('sort', sort)
    url.searchParams.set('type', sortStr)
    params.sort = sort
    params.type = sortStr

    let list = []
    for (let key in params) {
      list.push(`${key}=${params[key]}`)
    }
    // console.log(1382, list, list.join('&'))
    // 使用pushState更新浏览器历史记录
    // history.pushState({}, '', url)
    // pagination.value = false
    // await nextTick(() => {
    //   pagination.value = true
    // })
    // 重置页数为第1页
    // window.location.href = `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${date.value}-1/?${qs.stringify(params)}`;
    // console.log('1001-排序', url.searchParams)

    let hrefBefore = window.location.href.split('?')[0]
    // console.log(13823, `${hrefBefore}?${list.join('&')}`)
    return `${hrefBefore}?${list.join('&')}`
  }

  const handleOnlineService = () => {
    let serviceEl: any = document.getElementById('k_s_ol_chatWinSm_imgDiv') // ceshiidmap k_s_ol_chatWinSm
    // console.log('3341-', serviceEl);
    serviceEl.click()
  }

  const handleToDetail = (id: any) => {
    window.open(`/exhibition/${id}.html`)
  }

  const handleHotTab = (e: any) => {
    innerChainActive.value = e
  }

  const changePager = (page: number) => {
    router.push({
      path: `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${date.value}-${page}/`,
      query: route.query
    })
  }
  const toAllCity = () => {
    //  :to="`/exhibition-${firstIndustryId}-${secondIndustryId}-9999-0-0-${date}-1/?keyword=${keyword}`">
    // router.push({
    //   path: `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-9999-0-0-${date.value}-1/`,
    //   query: route.query
    // })
    // window.location.href = `/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-9999-0-0-${date.value}-1/`
    window.location.replace(`/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-9999-0-0-${date.value}-1/`)
  }
  const isShowKeyword = (key: string) => {
    if (key) {
      return `?keyword=${key}`
    } else {
      return ''
    }
  }

  const queryAreaList = async (id: number) => {
    // console.log('1870-', id, +id);
    if (+id > 1) {
      const area: any = areaList.value.find((item: any) => item.id === +id)
      cityList.value = area.areas
    } else if (+id === 1) {
      const res = await fetchCityByType({ type: '0' })
      if (res?.code === ResponseCode.SUCCESS) {
        cityList.value = _.get(res, 'data[0].areas')
      }
    }
  }

  const areaChange: (value?: string | number | boolean) => void = value => {
    // console.log('1867-', value);
    queryAreaList(value as number)
  }

  const get = _.get<any, string>

  // 监听路由参数变化，重新获取数据
  if (!process.server) {
    watch(
      () => [
        route.params.f,
        route.params.s,
        route.params.g,
        route.params.p,
        route.params.c,
        route.params.t,
        route.params.page
      ],
      async (newParams, oldParams) => {
        // 检查参数是否真的发生了变化
        if (JSON.stringify(newParams) !== JSON.stringify(oldParams)) {
          console.log('🔄 路由参数变化，重新获取数据:', newParams)

          // 更新响应式路由参数
          routeParams.firstIndustryId = (newParams[0] as string) || '0'
          routeParams.secondIndustryId = (newParams[1] as string) || '0'
          routeParams.area = (newParams[2] as string) || '9999'
          routeParams.province = (newParams[3] as string) || '0'
          routeParams.city = (newParams[4] as string) || '0'
          routeParams.date = (newParams[5] as string) || '0'
          routeParams.page = (newParams[6] as string) || '1'

          // 刷新数据
          await refresh()
        }
      },
      { deep: true }
    )
  }
  // console.log('853--', dates.value)
  return {
    lang_t: $t,
    firstIndustryId,
    secondIndustryId,
    area,
    province,
    city,
    date,
    page,
    pageNum,
    pageSize,
    listParams,
    type,
    keyword,
    keywordError,
    keywordPlaceholder,
    moreDate,
    moreCity,
    moreArea,
    pagination,
    isRecommond,
    activeSort,
    innerChainActive,
    cityList,
    azList,
    scale,
    hot,
    start_time,
    hotCityList,
    typeList,
    banner,
    newsList,
    industry,
    areas,
    fair,
    news,
    hotFair,
    checkTags,
    secondIndustry,
    provinceCityList,
    otherFairList,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    areaList,
    computedProvinceCityList,
    dates,
    datesHasData,
    getBrandName,
    getBrandNameIndustry,
    sectionTitle1,
    sectionTitle2,
    description,
    brandName,
    firstLink,
    handleKeywordInput,
    handleSearch,
    newUrl,
    handleAreaMore,
    handleCityMore,
    handleDateMore,
    handleGetFairList,
    handleGetFairList2,
    handleOnlineService,
    handleToDetail,
    handleHotTab,
    changePager,
    areaChange,
    get,
    isLogin,
    toAllCity,
    isShowKeyword,
    hotCityList2,
    refresh
  }
}
